import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SortDirection } from '@wdx/clmi/clmi-swagger-gen';
import { NavItem } from '@wdx/shared/utils';
import { FilterHandler } from '../../../classes/filter-handler.class';
import {
    ICON_SORT_ASC,
    ICON_SORT_DESC,
} from '../../../constants/icons.constants';
import { SortMenuValue } from '../../../models/sort-menu.model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'molecule-sort-menu',
    templateUrl: './molecule-sort-menu.component.html',
    host: { class: 'd-flex align-items-center' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MoleculeSortMenuComponent {
    @Input() sortMenu: NavItem<SortMenuValue>[];
    @Input() filterHandler: FilterHandler;

    readonly ICON_SORT_ASC = ICON_SORT_ASC.icon;
    readonly ICON_SORT_DESC = ICON_SORT_DESC.icon;

    get isAscending() {
        return (
            this.filterHandler.getSortDirection() === SortDirection.Ascending
        );
    }

    toggle(): void {
        this.filterHandler.toggleSortDirection();
    }

    select(navItem: NavItem<SortMenuValue>): void {
        if (!navItem.isInitialValue) {
            this.filterHandler.setSortDirection(
                navItem.value.sortDirection || SortDirection.Ascending,
                false,
            );
            this.filterHandler.setSortBy(navItem.value.sortBy);
        }
    }
}
